import {
	comMapping
} from "@/components/util/Function/comMapping";
export function getdata() {
	let obj = {
		formdata: {
			fiscalYear: "",
			fiscalYearState: ""
		},
		formlist: [{
				prop: "fiscalYear",
				label: "会计年度",
				type: "input",
				isnotnull: true,
			},
			{
				prop: "fiscalYearState",
				label: "财年状态",
				type: "input",
				slot: true,
				isnotnull: true,

			}
		],

		headData: [{
				title: "会计年度",
				prop: "fiscalYear",
				width: "100"
			}, {
				title: "财年状态",
				prop: "fiscalYearState",
				width: "100",
				custom: true
			}, {
				title: "期间状态",
				prop: "stateStr",
				width: "100",
			}, {
				title: "是否年度结转",
				prop: "yearStateStr",
				width: "100",
			},
			{
				title: "操作",
				prop: "cz",
				width: "200",
				fixed: "right",
				custom: true
			},
		],
		pagination: {
			pageNum: 1,
			pageSize: 50,
			total: 0,
			paginationkey: 0
		},
		headDatacn: [{
				title: "期间",
				prop: "pijian",
				width: "100"
			},
			{
				title: "期间状态",
				prop: "periodState",
				width: "200",
				fixed: "right",
				custom: true
			},{
				title: "是否年度结转",
				prop: "annualCarryForwardState",
				width: "200",
				fixed: "right",
				custom: true
			},
		],
		
		paginationcn: {
			pageNum: 1,
			pageSize: 50,
			total: 0,
			paginationkey: 0
		},
	}
	return obj
}
